import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Bannerfrom from "../components/bannerfrom";

function Banner({ data }) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="">
                <h1>
                  Deliver High-End Business Value With Google Cloud Services
                </h1>
              </div>
              <div className="banner_content_txt listing_flex">
                <p>
                  TekRevol assists clients in migrating, modernizing, and
                  transforming data with the Google Cloud Platform. Businesses
                  can disrupt their industrial domain with a data-driven cloud
                  strategy and AI-driven hyper-scale solutions.
                </p>
                <ul>
                  <li>GCP data transformation</li>
                  <li>AI hyper-scale solutions</li>
                  <li>Data-driven cloud strategy</li>
                  <li>GCP data migration</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
